import { Attributes, ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class RealisedGainsSummaryLookup extends ModelBase {
  
  public brokerAccountNumber: string = "";

  @Attributes.Date()
  public eventDate: Date = new Date();

  public instrument: string = "";

  public instrumentCode: string = "";

  public isin: string = "";

  public eventID: string = "";

  public eventName: string = "";

  public quantity: number | null = null;

  public proceedsNC: number | null = null;

  public baseValueSoldNC: number | null = null;

  public realisedGainNC: number | null = null;
}